import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import Cookies from 'universal-cookie';
import config from '../../../../config';
import { useNavigate } from 'react-router-dom';
import { fetchCuestionarioById } from '../../api/cuestionariosApi';

const parseRespuestas = (value) => {
  if (!value) return {};
  if (typeof value === 'string') {
    try { return JSON.parse(value); } catch (_e) { return {}; }
  }
  return typeof value === 'object' ? value : {};
};

const CUESTIONARIO_INCONTINENCIA = 1;

// Puntuaciones oficiales ICIQ-SF
export const FRECUENCIA_SCORES = [0, 1, 2, 3, 4, 5];
export const CANTIDAD_SCORES   = [0, 2, 4, 6];

export const calcularPuntuacionICIQ = (frecuencia, cantidad, impactoVida) => {
  const pFrecuencia = FRECUENCIA_SCORES[parseInt(frecuencia, 10)] ?? 0;
  const pCantidad   = CANTIDAD_SCORES[parseInt(cantidad, 10)]   ?? 0;
  const pImpacto    = Number(impactoVida) || 0;
  return pFrecuencia + pCantidad + pImpacto;
};

export const useCuestionarioSPForm = ({ idPaciente, idCuestionario }) => {
  const cookies = new Cookies();
  const token = cookies.get('TOKEN');
  const API_URL = `${config.API_BASE_URL}/cuestionario`;
  const navigate = useNavigate();
  const isEdit = Boolean(idCuestionario);

  const [frecuencia, setFrecuencia] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [impactoVida, setImpactoVida] = useState(0);
  const [factores, setFactores] = useState([]);
  const [openGood, setOpenGood] = useState(false);

  const puntuacionTotal = useMemo(
    () => calcularPuntuacionICIQ(frecuencia, cantidad, impactoVida),
    [frecuencia, cantidad, impactoVida]
  );

  useEffect(() => {
    if (!isEdit) return;
    fetchCuestionarioById(idCuestionario, idPaciente)
      .then((data) => {
        const r = parseRespuestas(data?.respuestas);
        setFrecuencia(r.frecuencia ?? '');
        setCantidad(r.cantidad ?? '');
        setImpactoVida(r.impactoVida ?? 0);
        setFactores(r.factores || []);
      })
      .catch((err) => console.error('Error fetching cuestionario SP:', err));
  }, [isEdit, idCuestionario, idPaciente]);

  const handleCheckboxChange = (e) => {
    const value = e.target.value;
    setFactores((prev) =>
      prev.includes(value) ? prev.filter((f) => f !== value) : [...prev, value]
    );
  };

  const guardarDatos = async () => {
    const datos = { frecuencia, cantidad, impactoVida, factores, puntuacionTotal };
    const headers = { Authorization: `Bearer ${token}` };
    try {
      if (isEdit) {
        try {
          await axios.put(`${API_URL}/${idCuestionario}`, datos, { headers });
        } catch (err) {
          if (err.response?.status === 404) {
            await axios.post(`${API_URL}/${idCuestionario}`, datos, { headers });
          } else throw err;
        }
      } else {
        await axios.post(`${API_URL}/${idPaciente}/${CUESTIONARIO_INCONTINENCIA}`, datos, { headers });
      }
      setOpenGood(true);
      setTimeout(() => navigate(isEdit ? -1 : `/paciente/${idPaciente}`), 1500);
    } catch (err) {
      console.error('Error guardando cuestionario SP:', err);
    }
  };

  return {
    frecuencia, setFrecuencia,
    cantidad, setCantidad,
    impactoVida, setImpactoVida,
    factores, handleCheckboxChange,
    puntuacionTotal,
    openGood, setOpenGood,
    isEdit,
    guardarDatos,
  };
};
